import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Services
import { AuthGuard } from './common/guards/auth.guard';
import { AuthSubmissionService } from './common/guards/subm.guard';

// Components
import { HomeComponent } from './components/home/home.component';
import { IndustriesComponent } from './components/home/industries/industries.component';
import { AccountComponent } from './components/account/account.component';
import { AccountIndustriesComponent } from './components/account/account-industries/account-industries.component';
import { AccountCaseComponent } from './components/account/account-case/account-case.component';
import { ConfirmationComponent } from './components/home/confirmation/confirmation.component';
import { RequestAccessComponent } from './components/home/request-access/request-access.component';
import { LoginPageComponent } from './components/home/login-page/login-page.component';
import { AccountExampleComponent } from './components/account/account-example/account-example.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'login', component: LoginPageComponent },
  { path: ':type/example-case-study', component: AccountExampleComponent },
  { path: 'onlineevents', redirectTo: '/industries/onlineevents', pathMatch: 'full' },

  { path: 'industries', component: AccountComponent, canActivate: [AuthGuard],
    children: [

      { path: ':type', component: AccountIndustriesComponent },
      { path: ':type/:type', component: AccountCaseComponent },

    ]
  },
  { path: 'request-access', component: RequestAccessComponent },
  { path: 'thank-you', component: ConfirmationComponent, canActivate: [AuthSubmissionService]},
  { path: ':id', component: IndustriesComponent },
  // Redirect '/onlineevents' to '/industries/onlineevents'
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
  providers: [AuthGuard, AuthSubmissionService]
})

export class AppRoutingModule {
}
